import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";

import {
  CADNIDATE_DETAIL,
  CANDIDATE_JOB_MAPPING,
  DELETE_CANDIDATE_JOB_MAPPING,
  GET_CANDIDATE_ACTIVE_LOG,
  GET_CANDIDATE_JOB_MAPPING,
  JOB_DETAIL,
  MATCHING_JOBS,
  SIMILAR_CADNIDATE,
  VIEW_CANDIDATE,
} from "./actionTypes";
import {
  deleteCandidateJobMapError,
  deleteCandidateJobMapSuccess,
  getCandidateActiveLogFail,
  getCandidateActiveLogSuccess,
  getCandidateDetailsFailed,
  getCandidateDetailsSuccess,
  getCandidateJobMappingDetailError,
  getCandidateJobMappingDetailSuccess,
  getCandidateJobMappingError,
  getCandidateJobMappingSuccess,
  getJobDetailsError,
  getJobDetailsSuccess,
  getMatchingJobError,
  getMatchingJobSuccess,
  getSimilarCandidateDetailError,
  getSimilarCandidateDetailSuccess,
  getSimilarCandidateSuccess,
  getSimilarCandidatesError,
} from "./actions";

import {
  getCall,
  getCandidateActiveData,
  getCandidateJobMap,
  getJobDetail,
  getMatchingJobs,
  getSimilarCandidate,
  getSimilarCandidateDetails,
} from "../../../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../../../common/constant/constantURL";

//view candidate
function* getCandiateDetails({ payload: { candidate } }) {
  try {
    let data = JSON.parse(localStorage.getItem("authUser"));
    var url;
    if (data.userType === "Recruiter") {
      url = constClass.REST_API_GET_RECRUITER_CANDIDATE_DATA;
    } else {
      url = constClass.REST_API_GET_CANDIDATE_DATA + `?id=${candidate}`;
    }
    //calling candidates count api
    let obj = {};
    obj["candidateId"] = candidate;
    let obj2 = {};
    obj2["candidate"] = obj;
    var responsJSON = yield call(getCall, url, obj2);

    yield put(getCandidateDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(getCandidateDetailsFailed(error));
  }
}
//matching jobs
function* getMatchingJobDetails({ payload: { matchingJob } }) {
  try {
    // This now calls the active GET /searchandmatch/match?candidateId=X&jobId=Y
    let url = `searchandmatch/match?candidateId=${matchingJob.candidateId}&jobId=${matchingJob.jobId}`;
    let responsJSON = yield call(getMatchingJobs, url);
    yield put(getMatchingJobSuccess(responsJSON));
  } catch (error) {
    yield put(getMatchingJobError(error));
  }
}

//matched job detail

function* getJobDetails({ payload: { jobDetail } }) {
  try {
    var url = constClass.REST_API_JOB_DETAIL;
    var responsJSON = yield call(getJobDetail, url, jobDetail);

    yield put(getJobDetailsSuccess(responsJSON));
  } catch (error) {
    yield put(getJobDetailsError(error));
  }
}

//Similar candidate
function* getSimilarCandidateData({ payload: { similarCandidate, page } }) {
  try {
    var url = `searchandmatch/match/list?jobId=${similarCandidate}&pageNo=${page}&pageSize=10`;
    var responsJSON = yield call(getSimilarCandidate, url);
    yield put(getSimilarCandidateSuccess(responsJSON));
  } catch (error) {
    yield put(getSimilarCandidatesError(error));
  }
}

//get similar candidate data
function* getSimilarCandidateD({ payload: { clickedCandidate } }) {
  try {
    var url = constClass.REST_API_SIMILAR_CANDIDATE_DETAIL;

    var responsJSON = yield call(
      getSimilarCandidateDetails,
      url,
      clickedCandidate,
    );
    yield put(getSimilarCandidateDetailSuccess(responsJSON));
  } catch (error) {
    yield put(getSimilarCandidateDetailError(error));
  }
}
// set candidate and  job mapping
function* setCandidateJobMapping({ payload: { candidateJob } }) {
  try {
    let data = JSON.parse(localStorage.getItem("authUser"));
    var url;
    if (data.userType === "Recruiter") {
      url = constClass.REST_API_RECRUITER_CANDIDATE_JOB_MAPPING;
    } else {
      url = constClass.REST_API_CANDIDATE_JOB_MAPPING;
    }
    var responsJSON = yield call(getCandidateJobMap, url, candidateJob);
    yield put(getCandidateJobMappingSuccess(responsJSON));
  } catch (error) {
    yield put(getCandidateJobMappingError(error));
  }
}

// get candidate and job mapping
function* getCandidateJobMapping({ payload: { getcandidateJob } }) {
  try {
    var url;
    let data = JSON.parse(localStorage.getItem("authUser"));
    if (data.userType === "Recruiter") {
      url = constClass.REST_API_RECRUITER_GET_CANDIDATE_JOB_MAPPING;
    } else {
      url = constClass.REST_API_GET_CANDIDATE_JOB_MAPPING;
    }

    var responsJSON = yield call(getCandidateJobMap, url, getcandidateJob);
    yield put(getCandidateJobMappingDetailSuccess(responsJSON));
  } catch (error) {
    yield put(getCandidateJobMappingDetailError(error));
  }
}
// Delete candidate and job mapping
function* deleteCandidateJobMapping({ payload: { deletecandidateJob } }) {
  try {
    let data = JSON.parse(localStorage.getItem("authUser"));
    var url;
    if (data.userType === "Recruiter") {
      url = constClass.REST_API_RECRUITER_DELETE_CANDIDATE_JOB_MAPPING;
    } else {
      url = constClass.REST_API_DELETE_CANDIDATE_JOB_MAPPING;
    }
    var responsJSON = yield call(getCandidateJobMap, url, deletecandidateJob);
    yield put(deleteCandidateJobMapSuccess(responsJSON));
  } catch (error) {
    yield put(deleteCandidateJobMapError(error));
  }
}

function* getActivityLogDataHandler({ payload: { data } }) {
  try {
    let url =
      constClass.REST_API_CANDIDATE_ACTIVE_LOG +
      `?page=${data.pageNumber}&pageSize=${data.pageSize}&candidateId=${data.candidateId}`;

    let responsJSON = yield call(getCandidateActiveData, url);
    yield put(getCandidateActiveLogSuccess(responsJSON));
  } catch (error) {
    yield put(getCandidateActiveLogFail(error));
  }
}

export function* watchViewCandidate() {
  yield takeEvery(VIEW_CANDIDATE, getCandiateDetails);
  yield takeEvery(MATCHING_JOBS, getMatchingJobDetails);
  yield takeEvery(JOB_DETAIL, getJobDetails);
  yield takeLatest(SIMILAR_CADNIDATE, getSimilarCandidateData);
  yield takeEvery(CADNIDATE_DETAIL, getSimilarCandidateD);
  yield takeEvery(CANDIDATE_JOB_MAPPING, setCandidateJobMapping);
  yield takeEvery(GET_CANDIDATE_JOB_MAPPING, getCandidateJobMapping);
  yield takeEvery(DELETE_CANDIDATE_JOB_MAPPING, deleteCandidateJobMapping);
  yield takeEvery(GET_CANDIDATE_ACTIVE_LOG, getActivityLogDataHandler);
}
function* viewCandidateSaga() {
  yield all([fork(watchViewCandidate)]);
}

export default viewCandidateSaga;
